import { Inject, Pipe, PipeTransform } from '@angular/core';
import { environment } from '@app/env';

@Pipe({
  name: 'shortDate'
})
export class ShortDatePipe implements PipeTransform {
  transform(timeString: string, localDate?: string) {
    // comparable date
    const date = new Date(timeString);
    date.setHours(0, 0, 0, 0);
    // today's date
    const today = localDate ? new Date(localDate) : new Date();
    today.setHours(0, 0, 0, 0);

    if (date.getTime() === today.getTime()) {
      if (environment.langShort === 'ET') {
        return 'Täna';
      }
      if (environment.langShort === 'EN') {
        return 'Today';
      }
      if (environment.langShort === 'RU') {
        return 'Сегодня';
      }
    }

    let day = date.toLocaleString('en-uk', { weekday: 'short' });
    if (environment.langShort === 'ru_EE') {
      day = date.toLocaleString('ru-RU', { weekday: 'short' });
    }
    if (environment.langShort === 'hi_IN') {
      day = date.toLocaleString('hi-IN', { weekday: 'short' });
    }
    if (environment.langShort === 'ET') {
      day = date.toLocaleString(['et-EE', 'eesti'], { weekday: 'short' });
    }
    return day;
  }
}
